import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
// import enLang from 'element-ui/lib/locale/lang/en'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import { initI18n } from './lang'
import { syncRequestContextCookies } from '@/utils/context-cookie'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import permission from '@/directive/permission' // permission directive
import i18nMixin from '@/mixins/i18n' // i18n mixin

import * as filters from './filters' // global filters

if (process.env.NODE_ENV === 'production') {
  const { mockXHR } = require('../mock')
  mockXHR()
}
async function bootstrap() {
  const i18n = await initI18n()
  syncRequestContextCookies(i18n.locale)
  Vue.use(Element, {
    size: Cookies.get('size') || 'medium', // set element-ui default size
    i18n: (key, value) => i18n.t(key, value)
  })
  // register global utility filters
  Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
  })
  // register global mixin for i18n
  Vue.mixin(i18nMixin)

  // register global directive
  Vue.use(permission)

  Vue.config.productionTip = false

  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
  })
}

bootstrap()
